"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFixedLimitAmountDollars = exports.LIFETIME_LIMIT_CANNOT_BE_SOURCED_FROM_ANNUAL_AMOUNT_MESSAGE = exports.RewardLimitAmountSource = void 0;
var RewardLimitAmountSource;
(function (RewardLimitAmountSource) {
    RewardLimitAmountSource["FIXED"] = "FIXED";
    RewardLimitAmountSource["REWARDS_DEPOSIT_BUNDLE_ENROLLMENT_AMOUNT"] = "REWARDS_DEPOSIT_BUNDLE_ENROLLMENT_AMOUNT";
})(RewardLimitAmountSource || (exports.RewardLimitAmountSource = RewardLimitAmountSource = {}));
exports.LIFETIME_LIMIT_CANNOT_BE_SOURCED_FROM_ANNUAL_AMOUNT_MESSAGE = 'A lifetime limit cannot be sourced from the bundle enrollment amount, which is annual';
const getFixedLimitAmountDollars = (limitRule) => {
    if (limitRule === undefined || limitRule.amountSource !== RewardLimitAmountSource.FIXED) {
        return null;
    }
    return limitRule.maxPurchaseAmountEligibleDollars;
};
exports.getFixedLimitAmountDollars = getFixedLimitAmountDollars;
